var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("General Stats")]),_c('b-table',{attrs:{"items":_vm.data,"fields":_vm.fields,"hover":"","striped":"","dark":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }